<template>
  <div>
    <sdPageHeader title="Xero Connection Warning">
      <template v-slot:subTitle>
        
        <a-button
          size="default"
          type="text"
          style="
            border: none;
            vertical-align: middle;
            transform: rotateZ(270deg);
          "
        >
          <span>
            <sdFeatherIcons
              style="line-height: 0; color: black !important"
              type="bar-chart"
              size="18"
          /></span>
        </a-button>
      </template>
    </sdPageHeader>
    <Main>
      <div>
      <sdCards>
      <div style="text-align: center; padding: 16px;">
        <a-alert
          message="Alert"
          description="You tried to connect an organisation from a different Xero account. Please connect organisations from the registered account."
          type="warning"
          show-icon
        />
      </div>
      </sdCards>
      </div>

    </Main>
  </div>
</template>
<script>
import { Main, TableWrapper } from "../styled";
import { computed, ref, defineComponent, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { UserTableStyleWrapper, Action, ProductCard } from "./style";
import * as FontAwesomeIcon from "@fortawesome/free-solid-svg-icons";
export default defineComponent({
  name: "dashboard",
  components: {
    Main,
    TableWrapper,
    UserTableStyleWrapper,
    ProductCard,
    FontAwesomeIcon,
    Action,
  },
 
  setup() {
    let empty = ref(true);
    let loading = ref(true);
    let orgdata = ref(null);
    const param = useRoute();
    const router = useRouter();
    const { state, dispatch } = useStore();
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
    onMounted(() => {
    });


    return {
      empty,
      orgdata,
      loading,
      
    };
  },
});
</script>
<style>
.ant-list-items {
  padding-top: 0px !important;
}

.highlighted {
  margin: 10px !important;
  border-spacing: 0 8px !important;
}

.product-list:hover {
  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
</style>